import React from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Шапка страницы скидки — только название типа скидки.
 * typeKey — ключ перевода типа, тот же, что в выпадашке «Действие» на списке скидок.
 */
function PageHeader({ typeKey }) {
	const { t } = useTranslation()

	return (
		<div className="page-header d-flex">
			<div className="d-flex text-truncate">
				<h4 className="vertical-center">
					{t(typeKey)}
				</h4>
			</div>
		</div>
	)
}

export default PageHeader
